import React from "react";
import HeadTitle from "../Components/Visibility/HeadTitle";
import Ready from "../Components/Visibility/Ready";

// 비식별화 화면배치
function Visibility() {
  return (
    <div>
      <HeadTitle />
      <Ready />
    </div>
  );
}

export default Visibility;
